import styles from "./LoadingPopup.module.css";

const LoadingPopup = ({ loadingText }: { loadingText: string }) => {
    return (
        <div className={styles.scrim}>
            <div className={styles.loadingPopup}>
                <div className={styles.loadingPopupContents}>
                    <span className={styles.loader}></span>
                    <p className={styles.loadingText}>{loadingText}</p>
                </div>
            </div>
        </div>
    );
};

export default LoadingPopup;
